import React, { Fragment, useEffect, useState } from 'react'
import DataGrid, {Pagenation} from '../../../../components/dataGrid'
import tremApi from '../../../../util/tremApi'
import G from '../../../../util/globalFunction'

export default props => {
    const {getPopupValue} = props
    const [dataStore, setDataStore] = useState({
        data: [],
        totalCount: 0,
        page: 0, 
        pageCount: 10
    })
    //검색(회원명)
    const [formData, setFormData] = useState({
        NAME: ''
    })

    const [selectGrid, setSelectGrid] = useState({})

  

    useEffect(() => {
        setUserGrid(1)
    },[])

    useEffect(() => {
        getPopupValue(selectGrid)
    },[selectGrid])

    // 회원정보
    const setUserGrid =  async props =>{
        const gridProps = {
            NAME:formData.NAME,
            page:props,
            rows:10
        }
        const grid = await tremApi('/r/user/list', G.removeEmptyUndefinedOrNull(gridProps))
        
        if(!grid) {
            alert(G.t('trem.lang.home.0836'))/* 오류발생 */
        }
        
        const totalCount = grid.total
        const pageCount = dataStore.pageCount
        const page = dataStore.page || 0
        const data = grid.rows

        setDataStore({...dataStore, totalCount, pageCount, page, data }) 
        
    }

    const { data, totalCount, pageCount, page } = dataStore
    
    // 페이지 이동
    const hangleChangePage = page => {
        setUserGrid(page+1)
    }

    const pageNationsInfo = { totalCount, pageCount, page, hangleChangePage }

    const searchBtn = () => {
        setUserGrid(1)
    }

    return (
        <div>
            <table className="popup_table_type1" style={{marginBottom: '10px'}}>
                <caption>회원검색 표 - 회원명으로 구성</caption>
                <tbody>
                <tr>
                    <th scope='row'><label htmlFor="NAME">{G.t('trem.lang.home.0629')}</label></th> {/* 회원명 */}
                    <td>
                        <input title="회원명 입력" id="NAME" name="NAME" onChange={e => setFormData({...formData, NAME: e.target.value})}/>
                    </td>
                </tr> 
                </tbody>
            </table>
            <div className="btn_type4" style={{marginBottom: '10px'}}>
                <a href="javascript:void(0);" onClick={searchBtn} className="red" style={{padding:[0, 0]}}>{G.t('trem.lang.home.0036')}</a>{/* 검색 */}
            </div>
            <DataGrid data={data}>
                <div title={G.t('trem.lang.home.0200')}/* 선택 */
                type="string" align="center" width="1fr" sort={false} filter={false} className="font-semibold"
                render = {(row, rowIndex, columnIndex, field)=>{
                    return(
                        <input
                            title="회원 선택"
                            type="checkbox"
                            name = "userCheckBox"
                            onKeyDown={(e)=>{
                                if(e.code==="Enter"){
                                    const checkboxes = document.getElementsByName('userCheckBox')
                                    for (let i = 0; i < checkboxes.length; i++) {
                                        checkboxes[i].checked = false
                                    }
                                    checkboxes[rowIndex].checked = true
                                    setSelectGrid(row)
                                }
                            }}
                            onChange={()=>{ 
                                const checkboxes = document.getElementsByName('userCheckBox')
                                for (let i = 0; i < checkboxes.length; i++) {
                                    checkboxes[i].checked = false
                                }
                                checkboxes[rowIndex].checked = true
                                setSelectGrid(row)
                                
                            }}
                        />
                    )
                }
                }/>
                <div title={G.t('trem.lang.home.0629')} field="NAME" type="string" align="center" width="1fr" sort={false} filter={false}/>{/* 회원명 */}
                <div title={G.t('trem.lang.home.0630')} field="INST_NAME" type="string" align="center" width="4fr" sort={false} filter={false} /* 소속(부서) */
                render ={(row)=>{
                    return(
                        <span>
                            {row?.COMPANY_NAME}
                            {row?.DEPT_NAME&&" ("+row.DEPT_NAME+")"}
                        </span>
                    )
                }}/>
            </DataGrid>
            <div className="self-center">
                <Pagenation {...pageNationsInfo} />
            </div>
        </div>
    )
}